module.exports = __webpack_public_path__ + "img/toledo.81ed7e62.png";